import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import useApiHelper from "../hooks/useApiHelper";
import { useEffect } from "react";

// public class VehicleStatsRequest
//   {
//     public string Query { get; set; }

//     public DateTime? ScheduledCollectionOn { get; set; }

//     public DateTime? ScheduledCollectionStart { get; set; }
//     public DateTime? ScheduledCollectionEnd   { get; set; }
//   }

export default function useVehicleAwaitingStats(filters?: any, pageName?: string) {
  const { post } = useApiHelper();
  const queryClient = useQueryClient();

  useEffect(() => {
    queryClient.invalidateQueries(["vehicle", "awaiting", "stats", pageName]);
  }, [filters]);

  // public class VehicleStatsResponse
  // {
  //   public List<EngineExportCount> EngineExportCounts { get; set; }

  //   public int ArrivingToday { get; set; }
  //   public int ArrivingTomorrow { get; set; }
  //   public int CollectedToday { get; set; }
  //   public int AwaitingCollection { get; set; }
  //   public int StartsAndDrives { get; set; }
  //   public int AwaitingDropOff { get; set; }
  // }

  const stats = useQuery(["vehicle", "awaiting", "stats"], () => post(`/vehicle/stats`, filters), {
    onSuccess: () => {
    },
    // 5 mins
    staleTime: 300000,
  });

  return { stats };
}